import { observer } from 'mobx-react';
import { T } from '../../../../../../../Translations';
import CloseIcon from '../../../../../../Cutesies/CloseIcon';
import GroupAvatar from '../../../../../../Cutesies/GroupAvatar';
import AddParticipantsToGroupFormStore from '../Store';
import { ExtendedGroupOption } from './GroupForm/GroupDynamicTypeaheadSelect/UseGroupDynamicTypeaheadSelect/Types';

interface Props {
  addParticipantsToGroupFormStore: AddParticipantsToGroupFormStore;
  group: ExtendedGroupOption<string>;
}

function GroupLabel({ addParticipantsToGroupFormStore, group }: Props) {
  return (
    <div className="flex px-3 py-3 justify-between items-center border rounded">
      <div className="flex items-center justify-between">
        <div className="w-8 h-8 mr-3 flex ">
          <GroupAvatar />
        </div>
        <div className="flex flex-col">
          <div className="text-sm">{group.label}</div>
          <div className="text-xs">
            <T kind="{{count}} Participant" count={group.participantCount} />
          </div>
        </div>
      </div>
      <div
        className="cursor-pointer"
        onClick={() => {
          addParticipantsToGroupFormStore.unsetGroup();
        }}
      >
        <CloseIcon variant="small" />
      </div>
    </div>
  );
}

export default observer(GroupLabel);
